import { render, staticRenderFns } from "./Expenses_ProjectionForm.vue?vue&type=template&id=6b1499d1&scoped=true&"
import script from "./Expenses_ProjectionForm.vue?vue&type=script&lang=js&"
export * from "./Expenses_ProjectionForm.vue?vue&type=script&lang=js&"
import style0 from "./Expenses_ProjectionForm.vue?vue&type=style&index=0&id=6b1499d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1499d1",
  null
  
)

export default component.exports